import { makeBaseTheme } from './DesignSystemProvider/ThemeContext/makeBaseTheme';
import { tokens } from './tokens';

// Need its own makeJoraTheme later on.
export const joraTheme = makeBaseTheme(tokens);
